module.exports = __webpack_public_path__ + "static/media/weather-dashboard.f665cf9b.jpg";